import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { FormGroup, ReactiveFormsModule } from '@angular/forms';
import { DatePickerModule } from 'primeng/datepicker';
import { DividerModule } from 'primeng/divider';
import { ImageModule } from 'primeng/image';
import { SelectModule } from 'primeng/select';
import { TextareaModule } from 'primeng/textarea';
import { SegmentedSelectComponent } from '@/shared/segmented-select/segmented-select.component';

@Component({
    selector: 'app-indagine-attacchi-bulloneria',
    templateUrl: './indagine-attacchi-bulloneria.component.html',
    imports: [DividerModule, DatePickerModule, CommonModule, SelectModule, ImageModule, ReactiveFormsModule, TextareaModule, SegmentedSelectComponent],
    standalone: true
})
export class IndagineAttacchiBulloneriaComponent {
    @Input() form!: FormGroup;
    @Input() tipoScambio!: 'SS' | 'SD' | 'SI';
    @Input() opzioniStatoUsura: any[] = [];

    ngOnInit(): void {  
    }
}
